import React from 'react';
import About from './AboutSection';
import Blog from './BlogSection';
import Career from './CareerSection';
import Category from './CategorySection';
import Contact from './ContactSection';
import Course from './CourseSection';
import Event from './EventSection';
import FunFact from './FunFactSection';
import Banner from './HomeThreeBanner';
import Testimonial from './TestimonialSection';
import Video from './VideoSection';
import Work from './WorkSection';
import Messages from './MessagesSection';
import DataState from '../../components/DataState';
import { useCollections } from '../../lib/api/collections';

const HomeThreeMain = () => {
  // Everything the home page needs is loaded together, so the sections appear at once.
  const content = useCollections('heroSlides', 'homeStats', 'programs', 'events', 'news', 'testimonials', 'messages');
  if (content.loading || content.error) return <DataState state={content} />;

  return (
    <main>
      <Banner />
      <Category />
      <About />
      <FunFact />
      <Course />
      <Video />
      <Work />
      <Career />
      <Testimonial />
      <Messages />
      <Contact />
      <Event />
      <Blog />
    </main>
  );
};
export default HomeThreeMain;
